import React from 'react';
import cn from 'classnames';

import { CAMPAIGNS_STATUSES } from 'const';
import classes from './statusLabel.module.scss';
import { IStatusLabel } from './types';

const ADVERTISING_STATUS_LABEL = {
	[CAMPAIGNS_STATUSES.DELAYED_START]: 'Временно остановлена',
	[CAMPAIGNS_STATUSES.FINISHED]: 'Завершена',
	[CAMPAIGNS_STATUSES.PAUSED]: 'Остановлена',
	[CAMPAIGNS_STATUSES.RUNNING]: 'Активна',
	[CAMPAIGNS_STATUSES.STOPPED]: 'Завершена',
	[CAMPAIGNS_STATUSES.WAITING]: 'Не запущена',
};
const NOT_PAID_LABEL = 'Не оплачена';

const StatusLabel: React.FC<IStatusLabel> = ({ 
	className,
	status,
	isPaid,
}) => {
	if (!status) return null;

	const isActive = status === CAMPAIGNS_STATUSES.RUNNING;
	const isPaused = [CAMPAIGNS_STATUSES.DELAYED_START, CAMPAIGNS_STATUSES.PAUSED].includes(status);

	return (
		<div className={cn(
			classes.statusLabel,
			className,
			{
				[classes.statusLabel__active]: isActive,
				[classes.statusLabel__paused]: isPaused,
			}
		)}>
			{status === CAMPAIGNS_STATUSES.WAITING && !isPaid ? NOT_PAID_LABEL : ADVERTISING_STATUS_LABEL[status]}
		</div>
	)
};

export default StatusLabel;
